import {
  BaseQueryApi,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";
import { RootState } from "../store";

// Pick API base URL based on env
const nodeApiBaseUrl =
  import.meta.env.VITE_NODE_ENV === "development"
    ? import.meta.env.VITE_API_BASE_URL_DEV
    : import.meta.env.VITE_NODE_ENV === "stage"
    ? import.meta.env.VITE_API_BASE_URL_STAGE
    : import.meta.env.VITE_API_BASE_URL_PROD;

// Pick dashboard login URL based on env
const dashboardLoginUrl =
  import.meta.env.VITE_NODE_ENV === "development"
    ? `${import.meta.env.VITE_API_CLIENT_DASHBOARD_DEV}/auth/sign-in`
    : import.meta.env.VITE_NODE_ENV === "stage"
    ? `${import.meta.env.VITE_API_CLIENT_DASHBOARD_STAGE}/auth/sign-in`
    : `${import.meta.env.VITE_API_CLIENT_DASHBOARD_PROD}/auth/sign-in`;

// Base query with token injection
const rawBaseQuery = fetchBaseQuery({
  baseUrl: nodeApiBaseUrl,
  credentials: "include",
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth.token;
    if (token) {
      console.log("---- setting auth token", token);
      headers.set("authorization", token);
    }
    return headers;
  },
});

export const baseQueryWithAuth = async (
  args: string | FetchArgs,
  api: BaseQueryApi,
  extraOptions: object
) => {
  const result = await rawBaseQuery(args, api, extraOptions);

  const currentUrl = window.location.href;
  console.log(currentUrl);
  console.log(result.error);
  if ((result as { error?: FetchBaseQueryError })?.error?.status === 401) {
    const currentUrl = window.location.href;
    localStorage.setItem("redirectAfterLogin", currentUrl);
    console.log("redirecting from here");
    // Redirect to correct dashboard login URL based on env
    window.location.href = `${dashboardLoginUrl}?redirect=${encodeURIComponent(
      currentUrl
    )}`;
  }

  return result;
};

export const nodeApi = createApi({
  reducerPath: "nodeApi",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["Node", "User", "Notifications", "PurchaseCreditAmount"],
  endpoints: (builder) => ({
    getClientCredit: builder.query({
      query: (email: string) =>
        `/client-ai-credits/get-balance-v2/?email=${email}`,
      providesTags: ["Node"],
    }),
  }),
});

export const { useGetClientCreditQuery } = nodeApi;
